export const CARRIER_SUBSIDIARY_OPTIONS = [
    { localizationSlug: 'ITG', value: 'itg', key: 'ITG' },
    {
        localizationSlug: 'ATLAS_MARINE',
        value: 'atlas_marine',
        key: 'ATLAS_MARINE',
    },
    { localizationSlug: 'WEST_END', value: 'west_end', key: 'WEST_END' },
    {
        localizationSlug: 'THREE_RIVERS',
        value: 'three_rivers',
        key: 'THREE_RIVERS',
    },
    { localizationSlug: 'XLR_8', value: 'xlr_8', key: 'XLR_8' },
];
export const SHIPPER_SUBSIDIARY_OPTIONS = [
    { localizationSlug: 'ITG', value: 'itg', key: 'ITG' },
];
export const ASSET_CARRIERS = [
    'atlas_marine',
    'west_end',
    'three_rivers',
    'xlr_8',
];
export const NON_ASSET_CARRIERS = ['itg'];
